import React, {useEffect, useMemo, useState} from 'react';
import {useFieldArray, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {RadioGroup} from "@mui/material";
import {
    ButtonMain, CheckboxMain,
    CreateCancelButtons,
    DateCalendarForm, DeleteModal, Loader,
    RadioMain,
    SelectAutocompletePagination,
    SelectMain,
    SwitchMain,
    TextToolTip
} from "components";
import {
    AllStatusesEnum,
    EscortAppPatientEnum,
    LegTypesEnum,
    RateTypes,
    Settings,
    SexTypes,
    TripTypesEnum,
} from "fragments";
import {
    calculateTotals,
    convertToTime, dontAllowChangesLegStatuses, FindError, FindLoad,
    FindSuccess, isEmptyObj, Notify, patientFilter, renderName,
    setDateOfTime,
    useModal,
    usePrimaryModal, useTimeRulesSync
} from "utils";
import {Svg} from "assets";
import {
    httpRequestsOnSuccessActions,
    legsActions,
    vehiclesActions,
    payerActions,
} from "store";
import {renderLeg} from "../constants";
import {AddAddress} from "./addAddress";
import {SingleLeg} from "./singleLeg";
import {RepeatWeekly} from "./repeatWeekly";
import {DeleteCancelTrip} from "./deleteCancelTrip";
import {LeaveModal} from "./LeaveModal";


const ACTION_TYPE_ADD = 'ADD_LEG'
const ACTION_TYPE_EDIT = 'EDIT_TRIP'
const ACTION_TYPE_SINGLE_TRIP = 'GET_SINGLE_TRIP'
const ACTION_TYPE_DELETE_LEG = 'DELETE_LEG'
const ACTION_TYPE_CANCEL_LEG = 'CANCEL_LEG'
const ACTION_TYPE_UN_CANCEL_LEG = 'UN_CANCEL_LEG'
const ACTION_TYPE_NO_SHOW_LEG = 'NO_SHOW_LEG'
const ACTION_TYPE_UN_NO_SHOW_LEG = 'UN_NO_SHOW_LEG'
const ACTION_TYPE_NEXT_PREV_TRIP = 'NEXT_PREV_TRIP'
const ACTION_TYPE_RECALCULATE = 'RECALCULATE_TRIP_REVENUE'

export const AddTrip = ({
                            tripId, tripDetails, afterSuccess = () => {
        }, requestParams
                        }) => {
        const ACTION_TYPE = tripId ? ACTION_TYPE_EDIT : ACTION_TYPE_ADD;
        const [isEditTrip, setIsEditTrip] = useState(false);
        const [isCheckedPatientAddress, setIsCheckedPatientAddress] = useState(false);
        const {vehiclesList, singleTrip, payersList} = useSelector((state) => ({
            vehiclesList: state.vehicles?.vehiclesList,
            singleTrip: state.legs.singleTrip,
            payersList: state.payers?.payersList,
        }));

        const {
            control,
            handleSubmit,
            setValue,
            watch,
            clearErrors,
            getValues,
            resetField,
            reset,
            formState: {errors, dirtyFields}
        } = useForm({
            defaultValues: {
                roundTrip: 'true',
                escort: false,
                nightCall: false,
                legs: tripDetails?.defaultLeg
            }
        });
        const {fields, append, remove} = useFieldArray({
            control,
            name: 'legs',
        });
        const dispatch = useDispatch();
        const {close} = useModal();
        const {openPrimary, closePrimary} = usePrimaryModal();
        const successAdd = FindSuccess(ACTION_TYPE);
        const loading = FindLoad(ACTION_TYPE);
        const successSingleTrip = FindSuccess(ACTION_TYPE_SINGLE_TRIP);
        const loadingSingleTrip = FindLoad(ACTION_TYPE_SINGLE_TRIP);
        const loadingNextPrevTrip = FindLoad(ACTION_TYPE_NEXT_PREV_TRIP);
        const loadingTripRecalculate = FindLoad(ACTION_TYPE_RECALCULATE);
        const beckErrorTrips = FindError(ACTION_TYPE);
        const beckErrorTripRecalculate = FindError(ACTION_TYPE_RECALCULATE);
        const legs = watch('legs');
        const patient = watch('patient');
        const payer = watch('payer');
        const roundTrip = watch('roundTrip') === 'true'
        const escortPicUp = legs?.find((leg) => leg?.type === LegTypesEnum.ESCORT_PICKUP);
        const escortDropOff = legs?.find((leg) => leg?.type === LegTypesEnum.ESCORT_DROPOFF);

        const {
            totalCallRevenue,
            totalRevenue,
            distance,
            total
        } = useMemo(() => calculateTotals(legs), [JSON.stringify(legs)]);

        useTimeRulesSync(tripId, legs, payer, getValues, setValue, watch);

        useEffect(() => {
            if (successAdd?.type) {
                dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
                close();
            }
        }, [successAdd])

        useEffect(() => {
            if (tripId) {
                dispatch(legsActions.getSingleTrip(tripId))
            }
            return () => {
                dispatch({
                    type: 'GET_SINGLE_TRIP_SUCCESS',
                    payload: null
                })
            }
        }, [tripId])


        useEffect(() => {
            const params = {
                status: AllStatusesEnum.ACTIVE,
            };
            dispatch(vehiclesActions.getVehicles((params)))
            dispatch(payerActions.getPayers((params)))
        }, []);


        useEffect(() => {
            if (successSingleTrip?.type) {
                dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_SINGLE_TRIP));
            }
            if (tripId && singleTrip) {
                reset({
                    ...singleTrip,
                    payer: payersList?.payers?.find((payer) => payer?.id === singleTrip?.payer),
                    roundTrip: singleTrip?.roundTrip ? 'true' : 'false',
                    legs: singleTrip?.legs?.map(({pickUp, dropOff, ...leg}) => {
                        return (
                            {
                                ...leg,
                                vehicle: leg?.vehicle?._id ? leg?.vehicle?._id : leg?.vehicle?.id ? leg?.vehicle?.id : null,
                                phone: leg?.phone ? leg?.phone : null,
                                dropOffAddress: dropOff?.address,
                                pickupAddress: pickUp?.address,
                                scheduledTime: pickUp?.scheduledTime ? convertToTime(pickUp?.scheduledTime) : null,
                                arrivedTime: pickUp?.arrivedTime ? convertToTime(pickUp?.arrivedTime) : null,
                                pickupTime: pickUp?.pickupTime ? convertToTime(pickUp?.pickupTime) : null,
                                dropOffTime: dropOff?.arrivedTime ? convertToTime(dropOff?.arrivedTime) : null,
                                apptTime: dropOff?.scheduledTime ? convertToTime(dropOff?.scheduledTime) : null,
                                pickupMileage: pickUp?.mileage,
                                dropOffMileage: dropOff?.mileage,
                                pickupFacility: pickUp?.facility ? pickUp?.facility : null,
                                dropOffFacility: dropOff?.facility ? dropOff?.facility : null,
                                status: leg?.status,
                            }
                        )
                    })
                }, {
                    keepDirty: false,
                    keepTouched: false,
                    keepErrors: false
                })
            }

        }, [singleTrip, successSingleTrip, tripId, isEditTrip]);

        useEffect(() => {
            if (beckErrorTripRecalculate?.error) {
                Notify(beckErrorTripRecalculate?.error, 'error')
            }

            if (beckErrorTrips?.error) {
                if (beckErrorTrips?.error?.startsWith('Leg can not be deleted')) {
                    Notify(beckErrorTrips?.error, 'error')
                }
                if (beckErrorTrips?.error === 'Payer was not found') {
                    Notify(beckErrorTrips?.error, 'error')
                }
            }
        }, [beckErrorTripRecalculate, beckErrorTrips]);

        // useEffect(() => {
        //     return () => {
        //         dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE_RECALCULATE));
        //         dispatch({
        //             type: GET_SINGLE_TRIP_SUCCESS,
        //             payload: null,
        //         })
        //     }
        // }, []);

        const settingsListTrip = () => [
            !singleTrip?.isCancelled && {
                Svg: Svg.EditInfoSvg,
                text: "Edit",
                handleClick: (e, toggleMenu) => {
                    toggleMenu();
                    setIsEditTrip(true)
                },
            },

            !singleTrip?.isCancelled && {
                Svg: Svg.RepeatSvg,
                text: "Repeat weekly",
                handleClick: (e, toggleMenu) => {
                    toggleMenu();
                    openPrimary(
                        <RepeatWeekly
                            anotherData={getValues()}
                            tripId={tripId}
                            afterSuccess={() => dispatch(legsActions.getSingleTrip(tripId, {}, true))}
                        />, {
                            noShowCloseBtn: true,
                            padding: "noPaddings",
                            maxWidth: 610
                        })
                },
            },

            {
                Svg: Svg.TrashSvg,
                text: "Delete",
                handleClick: (e, toggleMenu) => {
                    toggleMenu();
                    openPrimary(
                        <DeleteCancelTrip trip={singleTrip} afterSuccess={afterSuccess} requestParams={requestParams}/>, {
                            noShowCloseBtn: true,
                            padding: "noPaddings",
                            maxWidth: 610
                        })
                },
            },

            !singleTrip?.isCancelled && {
                Svg: Svg.CancelSvg,
                text: "Cancel Trip",
                handleClick: (e, toggleMenu) => {
                    toggleMenu();
                    openPrimary(
                        <DeleteCancelTrip trip={singleTrip} afterSuccess={afterSuccess} cancel
                                          requestParams={requestParams}/>, {
                            noShowCloseBtn: true,
                            padding: "noPaddings",
                            maxWidth: 610
                        })
                },
            },

            singleTrip?.isCancelled && {
                Svg: Svg.CancelSvg,
                text: "Un-cancel Trip",
                handleClick: (e, toggleMenu) => {
                    toggleMenu();
                    openPrimary(
                        <DeleteModal
                            handleDelete={() => {
                                dispatch(legsActions.unCancelTrip(tripId, {}, true, requestParams));
                            }}
                            actionType={'UN_CANCEL_TRIP'}
                            description={"This will restore the trip and all its canceled legs."}
                            title={`Are you sure you want to un-cancel trip?`}
                            afterSuccess={() => {
                                afterSuccess();
                                closePrimary()
                            }}
                            handleCancel={closePrimary}
                        />,
                        {
                            noShowCloseBtn: true,
                            padding: "noPaddings",
                            maxWidth: 407
                        },
                    );
                },
            },
        ];

        const settingsListLeg = (currentLeg, mainLeg) => {
            return [
                {
                    Svg: Svg.TrashSvg,
                    text: "Delete",
                    handleClick: (e, toggleMenu, item) => {
                        toggleMenu();
                        openPrimary(
                            <DeleteModal
                                handleDelete={() => {
                                    dispatch(legsActions.deleteLeg(item?.id, singleTrip?.id, false, requestParams));
                                }}
                                actionType={ACTION_TYPE_DELETE_LEG}
                                description={"This action is irreversible, and once deleted."}
                                title={`Are you sure you want to remove this leg ?`}
                                afterSuccess={() => {
                                    // afterSuccess();
                                    closePrimary();
                                    close();
                                }}
                                handleCancel={closePrimary}
                            />,
                            {
                                noShowCloseBtn: true,
                                padding: "noPaddings",
                                maxWidth: 407
                            },
                        );
                    },
                },
                currentLeg?.status !== EscortAppPatientEnum.CANCELLED &&
                {
                    Svg: Svg.CancelSvg,
                    text: "Cancel",
                    handleClick: (e, toggleMenu, item) => {
                        toggleMenu();
                        openPrimary(
                            <DeleteModal
                                handleDelete={() => {
                                    dispatch(legsActions.cancelLeg(item?.id, singleTrip?.id, false, requestParams));
                                }}
                                actionType={ACTION_TYPE_CANCEL_LEG}
                                description={"This action is irreversible and will cancel the trip permanently."}
                                title={`Are you sure you want to cancel this leg ?`}
                                afterSuccess={() => {
                                    // afterSuccess();
                                    closePrimary();
                                    close();
                                }}
                                handleCancel={closePrimary}
                            />,
                            {
                                noShowCloseBtn: true,
                                padding: "noPaddings",
                                maxWidth: 407
                            },
                        );
                    },
                },

                currentLeg?.status === EscortAppPatientEnum.CANCELLED &&
                {
                    Svg: Svg.CancelSvg,
                    text: "Un-cancel",
                    handleClick: (e, toggleMenu, item) => {
                        toggleMenu();
                        openPrimary(
                            <DeleteModal
                                handleDelete={() => {
                                    dispatch(legsActions.unCancelLeg(item?.id, singleTrip?.id, false, requestParams));
                                }}
                                actionType={ACTION_TYPE_UN_CANCEL_LEG}
                                description={"This will restore  all canceled legs."}
                                title={`Are you sure you want to un-cancel this leg ?`}
                                afterSuccess={() => {
                                    // afterSuccess();
                                    closePrimary();
                                    close();
                                }}
                                handleCancel={closePrimary}
                            />,
                            {
                                noShowCloseBtn: true,
                                padding: "noPaddings",
                                maxWidth: 410
                            },
                        );
                    },
                },
                (
                    mainLeg?.status !== EscortAppPatientEnum.NO_SHOW
                    &&
                    mainLeg?.status !== EscortAppPatientEnum.EN_ROUT
                    &&
                    mainLeg?.status !== EscortAppPatientEnum.COMPLETED
                ) &&
                {
                    Svg: Svg.NoShowSvg,
                    text: "No Show",
                    handleClick: (e, toggleMenu, item) => {
                        toggleMenu();
                        openPrimary(
                            <DeleteModal
                                handleDelete={() => {
                                    dispatch(legsActions.noShowLeg(item?.id, singleTrip?.id, false, requestParams));
                                }}
                                actionType={ACTION_TYPE_NO_SHOW_LEG}
                                description={"This action cannot be undone."}
                                title={`Are you sure you want to mark this leg as No Show?`}
                                customIcon={<Svg.NoShowModalSvg/>}
                                afterSuccess={() => {
                                    // afterSuccess();
                                    closePrimary();
                                    close();
                                }}
                                handleCancel={closePrimary}
                            />,
                            {
                                noShowCloseBtn: true,
                                padding: "noPaddings",
                                maxWidth: 410
                            },
                        );
                    },
                },

                currentLeg?.status === EscortAppPatientEnum.NO_SHOW &&
                {
                    Svg: Svg.NoShowSvg,
                    text: "Un-no-show",
                    handleClick: (e, toggleMenu, item) => {
                        toggleMenu();
                        openPrimary(
                            <DeleteModal
                                handleDelete={() => {
                                    dispatch(legsActions.unNoShowLeg(item?.id, singleTrip?.id, false, requestParams));
                                }}
                                actionType={ACTION_TYPE_UN_NO_SHOW_LEG}
                                description={"This action cannot be undone."}
                                title={`Are you sure you want to mark this leg as Un No Show?`}
                                customIcon={<Svg.NoShowModalSvg/>}
                                afterSuccess={() => {
                                    // afterSuccess();
                                    closePrimary();
                                    close();
                                }}
                                handleCancel={closePrimary}
                            />,
                            {
                                noShowCloseBtn: true,
                                padding: "noPaddings",
                                maxWidth: 410
                            },
                        );
                    },
                },
            ]
        };

        const changeAddress = (path, currentFacilityPath, originalPath, facilityPath, type) => {
            const address = watch(path);
            const facility = watch(currentFacilityPath);

            openPrimary(
                <AddAddress
                    legs={legs}
                    address={address}
                    facility={facility}
                    setValue={setValue}
                    currentPath={path}
                    currentFacilityPath={currentFacilityPath}
                    clearErrors={clearErrors}
                    type={type}
                    originalPath={originalPath}
                    facilityPath={facilityPath}
                />, {
                    noShowCloseBtn: true,
                    padding: "noPaddings",
                    maxWidth: 610
                })
        }

        const handleSlide = (id) => {
            if (id) {
                dispatch(legsActions.getSingleTrip(id))
            }
        }

        const recalculateTripRevenue = () => {
            dispatch(legsActions.recalculateTripRevenue(singleTrip?.id))
        }

        const handleLeaveSaving = () => {
            openPrimary(
                <LeaveModal
                    handleCancel={() => {
                        setIsEditTrip(false);
                        closePrimary();
                    }}
                    handleSave={handleSubmit(onSubmit)}
                    actionType={ACTION_TYPE}
                />, {
                    noShowCloseBtn: true,
                    padding: "noPaddings",
                    maxWidth: 407
                })
        }

        const handleSelectPatient = (item) => {
            const currentLegs = getValues('legs');

            if (item?.insurance?.id || item?.insurance?._id) {
                // setValue('payer', item.insurance._id || item.insurance.id, {shouldDirty: true});
                setValue('payer', item.insurance, {shouldDirty: true});

            } else {
                resetField('payer');
            }

            const updatedLegs = currentLegs.map((leg) => {
                switch (leg.type) {
                    case LegTypesEnum.ESCORT_PICKUP:
                        return {...leg, pickupAddress: item?.insurance?.address || null};
                    case LegTypesEnum.ESCORT_DROPOFF:
                        return {...leg, dropOffAddress: item?.insurance?.address || null};
                    default:
                        return leg;
                }
            });
            setValue('legs', updatedLegs, {shouldDirty: true});
        };

        const handleSelectPayer = (item) => {
            const currentLegs = getValues('legs');

            const updatedLegs = currentLegs.map((leg) => {
                if (leg.status && !dontAllowChangesLegStatuses(leg.status)) {
                    switch (leg.type) {
                        case LegTypesEnum.ESCORT_PICKUP:
                            return {...leg, pickupAddress: item?.address || null};
                        case LegTypesEnum.ESCORT_DROPOFF:
                            return {...leg, dropOffAddress: item?.address || null};
                        default:
                            return leg;
                    }
                } else {
                    return leg
                }

            });
            setValue('legs', updatedLegs, {shouldDirty: true});
        }

        const usePatientAddresses = (e) => {
            setIsCheckedPatientAddress(e.target.checked);

            if (e.target.checked && patient?.address?.formattedAddress) {
                const currentLegs = getValues('legs');

                const updatedLegs = currentLegs.map((leg) => {
                    if (!dontAllowChangesLegStatuses(leg?.status)) {
                        switch (leg.type) {
                            case LegTypesEnum.APPOINTMENT:
                                return {...leg, pickupAddress: patient.address};
                            case LegTypesEnum.RETURN:
                                return {...leg, dropOffAddress: patient.address};
                            case LegTypesEnum.ESCORT_PICKUP:
                                return {...leg, dropOffAddress: patient.address};
                            case LegTypesEnum.ESCORT_DROPOFF:
                                return {...leg, pickupAddress: patient.address};
                            case LegTypesEnum.MED_DROP:
                                return {...leg, dropOffAddress: patient.address};
                            case LegTypesEnum.MED_DROP_RETURN:
                                return {...leg, pickupAddress: patient.address};
                            case LegTypesEnum.BUS_ROUTE:
                                return {...leg, pickupAddress: patient.address};
                            case LegTypesEnum.BUS_ROUTE_RETURN:
                                return {...leg, dropOffAddress: patient.address};
                            default:
                                return leg;
                        }
                    } else {
                        return leg;
                    }

                });
                setValue('legs', updatedLegs, {shouldDirty: true});
            }
        }

        const handleEscortChange = (e) => {
            if (e.target.checked) {
                const apptLeg = fields.find(leg => leg?.type === LegTypesEnum.APPOINTMENT);
                const escortPicUpSingle = tripId && singleTrip?.legs?.find((leg) => leg.type === LegTypesEnum.ESCORT_PICKUP) || {};
                const escortDropOffSingle = tripId && singleTrip?.legs?.find((leg) => leg.type === LegTypesEnum.ESCORT_DROPOFF) || {};

                append([
                    {
                        ...escortPicUpSingle,
                        vehicle: tripId && escortPicUpSingle?.vehicle?._id ? tripId && escortPicUpSingle?.vehicle?._id : escortPicUpSingle?.vehicle?.id ? escortPicUpSingle?.vehicle?.id : null,
                        type: LegTypesEnum.ESCORT_PICKUP,
                        scheduledTime: tripId && escortPicUpSingle?.pickUp?.scheduledTime ? convertToTime(escortPicUpSingle?.pickUp?.scheduledTime) : null,
                        arrivedTime: tripId && escortPicUpSingle?.pickUp?.arrivedTime ? convertToTime(escortPicUpSingle?.pickUp?.arrivedTime) : null,
                        pickupTime: tripId && escortPicUpSingle?.pickUp?.pickupTime ? convertToTime(escortPicUpSingle?.pickUp?.pickupTime) : null,
                        dropOffTime: tripId && escortPicUpSingle?.dropOff?.arrivedTime ? convertToTime(escortPicUpSingle?.dropOff?.arrivedTime) : null,
                        pickupMileage: tripId && escortPicUpSingle?.pickUp?.mileage || null,
                        dropOffMileage: tripId && escortPicUpSingle?.dropOff?.mileage || null,
                        pickupFacility: tripId && escortPicUpSingle?.pickUp?.facility ? escortPicUpSingle?.pickUp?.facility : null,
                        dropOffFacility: tripId && escortPicUpSingle?.dropOff?.facility ? escortPicUpSingle?.dropOff?.facility : null,
                        phone: tripId && escortPicUpSingle?.phone ? escortPicUpSingle?.phone : null,

                        pickupAddress: tripId && escortPicUpSingle?.pickUp?.address ? escortPicUpSingle?.pickUp?.address : payer?.address?.formattedAddress ? payer?.address : {formattedAddress: null},
                        dropOffAddress: tripId && escortPicUpSingle?.dropOff?.address ? escortPicUpSingle?.dropOff?.address : apptLeg?.pickupAddress?.formattedAddress ? apptLeg?.pickupAddress : {formattedAddress: null},
                    },
                    {
                        ...escortDropOffSingle,
                        vehicle: tripId && escortDropOffSingle?.vehicle?._id ? tripId && escortDropOffSingle?.vehicle?._id : escortDropOffSingle?.vehicle?.id ? escortDropOffSingle?.vehicle?.id : null,
                        type: LegTypesEnum.ESCORT_DROPOFF,
                        scheduledTime: tripId && escortDropOffSingle?.pickUp?.scheduledTime ? convertToTime(escortDropOffSingle?.pickUp?.scheduledTime) : null,
                        arrivedTime: tripId && escortDropOffSingle?.pickUp?.arrivedTime ? convertToTime(escortDropOffSingle?.pickUp?.arrivedTime) : null,
                        pickupTime: tripId && escortDropOffSingle?.pickUp?.pickupTime ? convertToTime(escortDropOffSingle?.pickUp?.pickupTime) : null,
                        dropOffTime: tripId && escortDropOffSingle?.dropOff?.arrivedTime ? convertToTime(escortDropOffSingle?.dropOff?.arrivedTime) : null,
                        pickupMileage: tripId && escortDropOffSingle?.pickUp?.mileage || null,
                        dropOffMileage: tripId && escortDropOffSingle?.dropOff?.mileage || null,
                        pickupFacility: tripId && escortDropOffSingle?.pickUp?.facility ? escortDropOffSingle?.pickUp?.facility : null,
                        dropOffFacility: tripId && escortDropOffSingle?.dropOff?.facility ? escortDropOffSingle?.dropOff?.facility : null,
                        phone: tripId && escortDropOffSingle?.phone ? escortDropOffSingle?.phone : null,

                        pickupAddress: tripId && escortDropOffSingle?.pickUp?.address ? escortDropOffSingle?.pickUp?.address : apptLeg?.pickupAddress?.formattedAddress ? apptLeg?.pickupAddress : {formattedAddress: null},
                        dropOffAddress: tripId && escortDropOffSingle?.dropOff?.address ? escortDropOffSingle?.dropOff?.address : payer?.address?.formattedAddress ? payer?.address : {formattedAddress: null},
                    },
                ]);
            } else {
                const currentLegs = getValues('legs');
                const updatedIndexes = [];
                currentLegs.forEach((leg, index) => {
                    if (
                        leg.type === LegTypesEnum.ESCORT_PICKUP ||
                        leg.type === LegTypesEnum.ESCORT_DROPOFF || !leg?.type
                    ) {
                        updatedIndexes.push(index);
                    }
                });
                updatedIndexes.sort((a, b) => b - a).forEach((index) => {
                    remove(index);
                });
            }
        };

        const round = (type) => {
            const currentLegs = getValues('legs');

            if (type === 'oneWay') {
                const filteredLegs = currentLegs.filter(
                    (leg) =>
                        leg.type &&
                        ![
                            LegTypesEnum.RETURN,
                            LegTypesEnum.MED_DROP_RETURN,
                            LegTypesEnum.BUS_ROUTE_RETURN,
                        ].includes(leg.type)
                );
                setValue('legs', filteredLegs, {shouldDirty: true});
                return;
            }

            const tripMap = {
                [TripTypesEnum.APPOINTMENT]: {
                    baseType: LegTypesEnum.APPOINTMENT,
                    returnType: LegTypesEnum.RETURN,
                },
                [TripTypesEnum.MED_DROP]: {
                    baseType: LegTypesEnum.MED_DROP,
                    returnType: LegTypesEnum.MED_DROP_RETURN,
                },
                [TripTypesEnum.BUS_ROUTE]: {
                    baseType: LegTypesEnum.BUS_ROUTE,
                    returnType: LegTypesEnum.BUS_ROUTE_RETURN,
                },
            };


            const config = tripMap[tripDetails?.tripType];

            if (!config) return;

            const baseLeg = legs?.find((leg) => leg.type === config.baseType);
            const returnSingleLeg = singleTrip?.legs?.find((leg) => leg.type === config.returnType) || {};
            if (!baseLeg) return;

            const dropOffAddress = baseLeg?.dropOffAddress?.formattedAddress
                ? {...baseLeg.dropOffAddress}
                : {formattedAddress: null};

            const pickupAddress = baseLeg?.pickupAddress?.formattedAddress
                ? {...baseLeg.pickupAddress}
                : {formattedAddress: null};


            if (config.returnType) {
                append({
                    ...returnSingleLeg,
                    vehicle: tripId && returnSingleLeg?.vehicle?._id ? returnSingleLeg?.vehicle?._id : tripId && returnSingleLeg?.vehicle?.id ? returnSingleLeg?.vehicle?.id : null,
                    type: config.returnType,
                    scheduledTime: tripId && returnSingleLeg?.pickUp?.scheduledTime ? convertToTime(returnSingleLeg?.pickUp?.scheduledTime) : null,
                    arrivedTime: tripId && returnSingleLeg?.pickUp?.arrivedTime ? convertToTime(returnSingleLeg?.pickUp?.arrivedTime) : null,
                    pickupTime: tripId && returnSingleLeg?.pickUp?.pickupTime ? convertToTime(returnSingleLeg?.pickUp?.pickupTime) : null,
                    dropOffTime: tripId && returnSingleLeg?.dropOff?.arrivedTime ? convertToTime(returnSingleLeg?.dropOff?.arrivedTime) : null,
                    pickupMileage: tripId && returnSingleLeg?.pickUp?.mileage || null,
                    dropOffMileage: tripId && returnSingleLeg?.dropOff?.mileage || null,
                    pickupFacility: tripId && returnSingleLeg?.pickUp?.facility ? returnSingleLeg?.pickUp?.facility : null,
                    dropOffFacility: tripId && returnSingleLeg?.dropOff?.facility ? returnSingleLeg?.dropOff?.facility : null,
                    phone: tripId && returnSingleLeg?.phone ? returnSingleLeg?.phone : null,
                    pickupAddress: tripId && returnSingleLeg?.pickUp?.address || dropOffAddress,
                    dropOffAddress: tripId && returnSingleLeg?.dropOff?.address || pickupAddress,
                });
            }
        };

        const onSubmit = (data) => {
            const params = {
                ...data,
                patient: data.patient?._id || data.patient?.id,
                payer: data.payer?._id || data.payer?.id,
                legs: data.legs?.filter((l) => l?.type)?.map((leg) => (
                    {
                        ...leg,
                        scheduledTime: (data?.serviceDate && leg?.scheduledTime) && setDateOfTime(data?.serviceDate, leg?.scheduledTime),
                        pickupTime: (data?.serviceDate && leg?.pickupTime) && setDateOfTime(data?.serviceDate, leg?.pickupTime),
                        dropOffTime: (data?.serviceDate && leg?.dropOffTime) && setDateOfTime(data?.serviceDate, leg?.dropOffTime),
                        arrivedTime: (data?.serviceDate && leg?.arrivedTime) && setDateOfTime(data?.serviceDate, leg?.arrivedTime),
                        apptTime: (data?.serviceDate && leg?.apptTime) && setDateOfTime(data?.serviceDate, leg?.apptTime),
                        dropOffFacility: leg?.dropOffFacility,
                        pickupFacility: leg?.pickupFacility,
                    }
                )),
                roundTrip: data.roundTrip === 'true'
            }
            if (isEditTrip) {
                dispatch(legsActions.editTrip(singleTrip?.id, params, true, requestParams))
            } else {
                dispatch(legsActions.addLeg(params, requestParams))

            }
        }

        return (
            <form
                className={`add-dispatch-board-wrapper ${loadingSingleTrip || loadingNextPrevTrip ? 'add-dispatch-board-wrapper-load' : ''}`}
                onSubmit={handleSubmit(onSubmit)}
            >
                {(loadingSingleTrip || loadingNextPrevTrip)
                    ? <Loader styles={{minWidth: 100, minHeight: 100}}/>
                    :
                    <div>
                        <div className="modal-header-main">
                            <div className='add-dispatch-board-slide-wrapper'>
                                {(!isEditTrip && tripId && singleTrip?.id) &&
                                    <button
                                        type='button'
                                        disabled={!singleTrip?.previousId}
                                        className='add-dispatch-board-slide-btn add-dispatch-board-slide-prev'
                                        style={{opacity: !singleTrip?.previousId ? '.7' : ''}}
                                        onClick={() => handleSlide(singleTrip?.previousId)}
                                    >
                                        <Svg.ArrowRightSlide/>
                                    </button>
                                }
                                <h2 className="modal-header-title">{singleTrip?.id && tripId ? `Trip` : 'Create New Trip'} </h2>
                                {(!isEditTrip && tripId && singleTrip?.id) &&
                                    <button
                                        type='button'
                                        disabled={!singleTrip?.nextId}
                                        className='add-dispatch-board-slide-btn add-dispatch-board-slide-next'
                                        style={{opacity: !singleTrip?.nextId ? '.7' : ''}}
                                        onClick={() => handleSlide(singleTrip?.nextId)}
                                    >
                                        <Svg.ArrowRightSlide/>
                                    </button>
                                }
                            </div>
                            <div className="align-center" style={{gap: 8}}>
                                <SwitchMain
                                    label='Night Call'
                                    name='nightCall'
                                    control={control}
                                    disabled={singleTrip?.id && tripId && !isEditTrip}
                                />

                                {(tripDetails?.tripType === TripTypesEnum.APPOINTMENT) &&
                                    <SwitchMain
                                        onChange={handleEscortChange}
                                        label='Escort'
                                        name='escort'
                                        control={control}
                                        disabled={
                                            (tripId && singleTrip?.id && !isEditTrip) ||
                                            (singleTrip?.id &&
                                                ((escortPicUp?.status && (escortPicUp?.status !== EscortAppPatientEnum.OPEN && escortPicUp?.status !== EscortAppPatientEnum.ASSIGNED && escortPicUp?.status !== EscortAppPatientEnum.CANCELLED))
                                                    || (escortDropOff?.status && (escortDropOff?.status !== EscortAppPatientEnum.OPEN && escortDropOff?.status !== EscortAppPatientEnum.ASSIGNED && escortDropOff?.status !== EscortAppPatientEnum.CANCELLED)))
                                            )
                                        }
                                    />
                                }

                                <div className="line"/>
                                <RadioGroup className='radio-group-oneWayOrRoundTrip'>
                                    <RadioMain
                                        control={control}
                                        name='roundTrip'
                                        label='One Way'
                                        value={'false'}
                                        disabled={(tripId && singleTrip?.id && !isEditTrip) || !roundTrip}
                                        onClick={() => round('oneWay')}
                                    />

                                    <div className="line"/>
                                    <RadioMain
                                        control={control}
                                        name='roundTrip'
                                        label='Round Trip'
                                        value={'true'}
                                        disabled={(tripId && singleTrip?.id && !isEditTrip) || roundTrip}
                                        onClick={() => round('roundTrip')}
                                    />
                                </RadioGroup>

                                {tripId && singleTrip?.id &&
                                    <Settings
                                        className='settings-header-create-trip'
                                        list={settingsListTrip}
                                    />
                                }

                                {tripId && singleTrip?.id && !singleTrip?.isCancelled &&
                                    <div className="line"/>
                                }

                                <button
                                    className="modal-close-btn-main"
                                    type="button"
                                    onClick={() => {
                                        if (!isEmptyObj(dirtyFields) && singleTrip?.id && isEditTrip) {
                                            handleLeaveSaving()
                                        } else {
                                            close()
                                        }
                                    }}
                                >
                                    <Svg.CloseSvg/>
                                </button>
                            </div>
                        </div>

                        <div className="modal-body-main" style={{display: 'flex', flexDirection: 'column', gap: 16}}>
                            <div className="trip-details-wrapper">
                                <h3 className='dispatch-board-details-title'>
                                    Trip Details
                                </h3>

                                <div className='trip-details-box'>
                                    <div className='dispatch-board-input-wrapper' style={{minWidth: 205}}>
                                        <p className='dispatch-board-input-label'>
                                            DOS
                                        </p>
                                        <DateCalendarForm
                                            control={control}
                                            name='serviceDate'
                                            rules={{
                                                required: true
                                            }}
                                            dontShowError
                                            disabled={tripId && singleTrip?.id && !isEditTrip}
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper'>
                                        <p className='dispatch-board-another-info-text' style={{whiteSpace: 'nowrap'}}>
                                            Dist.
                                        </p>

                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={Number(distance?.toFixed(2))}
                                            content={Number(distance?.toFixed(2))}
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper'>
                                        <p className='dispatch-board-another-info-text' style={{whiteSpace: 'nowrap'}}>
                                            Call Rate
                                        </p>

                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={totalCallRevenue}
                                            content={totalCallRevenue}
                                            priceRow
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper'>
                                        <p className='dispatch-board-another-info-text' style={{whiteSpace: 'nowrap'}}>
                                            Dist. Rate
                                        </p>
                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={totalRevenue}
                                            content={totalRevenue}
                                            priceRow
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper'>
                                        <p className='dispatch-board-another-info-text' style={{whiteSpace: 'nowrap'}}>
                                            Total:
                                        </p>
                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={total}
                                            content={total}
                                            priceRow
                                        />
                                    </div>
                                    {tripId && payer && !singleTrip?.isCancelled &&
                                        <ButtonMain
                                            text='Recalculate'
                                            load={!!loadingTripRecalculate?.length}
                                            type='button'
                                            startIcon={<Svg.RefreshSvg/>}
                                            buttonMainStyles={{padding: '6px 12px', width: 144, minWidth: 144, height: 36}}
                                            onClick={recalculateTripRevenue}
                                        />
                                    }
                                </div>
                            </div>

                            <div className="patient-details-wrapper">
                                <div className='space-between'>
                                    <h3 className='dispatch-board-details-title'>
                                        Patient
                                    </h3>
                                    <CheckboxMain
                                        label={`Use selected patient’s address`}
                                        onChange={usePatientAddresses}
                                        checked={isCheckedPatientAddress}
                                        disabled={(singleTrip?.id && tripId && !isEditTrip) || !patient}
                                    />
                                </div>

                                <div className='patient-details-box'>
                                    <div style={{maxWidth: 250, width: '100%'}}>
                                        <SelectAutocompletePagination
                                            control={control}
                                            name="patient"
                                            placeholder="Select Patient"
                                            renderLabel={(option) => {
                                                if (option?.insurance?.name) {
                                                    return `${renderName(option)} (${option?.insurance?.name})`
                                                }

                                                return `${renderName(option)}`
                                            }}

                                            renderOption={(option) => {
                                                if (option?.insurance?.name) {
                                                    return <p> {renderName(option)} <br/> ({option?.insurance?.name})</p>
                                                }

                                                return `${renderName(option)}`
                                            }}
                                            async={true}
                                            apiUrl="/patients"
                                            handleChange={handleSelectPatient}
                                            filterOptions={patientFilter}
                                            sendParams={{arrayKey: "patients"}}
                                            paramsBuilder={(pageParam, searchParam) => {
                                                return (
                                                    searchParam ? {
                                                            skip: (pageParam - 1) * 50,
                                                            limit: 50,
                                                            searchKey: 'fullName',
                                                            searchValue: searchParam
                                                        }
                                                        :
                                                        {
                                                            skip: (pageParam - 1) * 50,
                                                            limit: 50,
                                                        }
                                                )
                                            }}
                                            allowError={false}
                                            disabled={tripId && singleTrip?.id && !isEditTrip}
                                            rules={{
                                                required: true
                                            }}
                                        />
                                    </div>
                                    <div style={{maxWidth: 200, width: '100%'}}>
                                        <SelectMain
                                            list={payersList?.payers}
                                            renderLabel={(option) => option?.name}
                                            name="payer"
                                            control={control}
                                            placeholder="Select Payer"
                                            loadType="GET_PAYERS"
                                            disabled={tripId && singleTrip?.id && !isEditTrip}
                                            allowError={false}
                                            handleChange={handleSelectPayer}
                                            // selectedValue='id'
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper' style={{maxWidth: 180}}>
                                        <p className='dispatch-board-another-info-text'
                                           style={{whiteSpace: 'nowrap'}}
                                        >
                                            Phone:
                                        </p>
                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={patient?.phone}
                                            content={patient?.phone}
                                            phoneRow
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper' style={{maxWidth: 102}}>
                                        <p className='dispatch-board-another-info-text' style={{whiteSpace: 'nowrap'}}>
                                            Sex:
                                        </p>
                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={SexTypes[patient?.sex]}
                                            content={SexTypes[patient?.sex]}
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper' style={{maxWidth: 140}}>
                                        <p className='dispatch-board-another-info-text' style={{whiteSpace: 'nowrap'}}>
                                            DOB:
                                        </p>
                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={patient?.dob}
                                            content={patient?.dob}
                                            dateRow
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper' style={{maxWidth: 160}}>
                                        <p className='dispatch-board-another-info-text' style={{whiteSpace: 'nowrap'}}>
                                            MRN:
                                        </p>

                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={patient?.mrnNumber}
                                            content={patient?.mrnNumber}
                                        />
                                    </div>

                                    <div className='dispatch-board-another-info-wrapper' style={{maxWidth: 137}}>
                                        <p className='dispatch-board-another-info-text' style={{whiteSpace: 'nowrap'}}>
                                            LOS:
                                        </p>
                                        <TextToolTip
                                            classNameText='dispatch-board-another-info-text'
                                            text={RateTypes[patient?.los]}
                                            content={RateTypes[patient?.los]}
                                        />
                                    </div>
                                </div>
                            </div>


                            {
                                // [...fields].sort((a, b) => {
                                //     const order = {
                                //         ESCORT_PICKUP: 0,
                                //         APPOINTMENT: 1,
                                //         RETURN: 2,
                                //         ESCORT_DROPOFF: 3
                                //     };
                                //     return order[a?.type] - order[b?.type];
                                // })
                                fields.filter((f) => f.type).map((currentItem, index) => {
                                    const renderEnumValues = renderLeg(currentItem?.type)
                                    return <SingleLeg
                                        item={currentItem}
                                        key={`${currentItem.type}-${index}`}
                                        index={index}
                                        currentTripId={tripId}
                                        singleTrip={singleTrip}
                                        currentItem={renderEnumValues}
                                        isEditTrip={isEditTrip}
                                        control={control}
                                        changeAddress={(path, currentFacilityPath, originalPath, facilityPath) => changeAddress(path, currentFacilityPath, originalPath, facilityPath, currentItem?.type)}
                                        vehiclesList={vehiclesList}
                                        errors={errors}
                                        watch={watch}
                                        settingsListLeg={settingsListLeg}
                                        setValue={setValue}
                                    />
                                })}
                        </div>

                        {(!tripId || isEditTrip) &&
                            <CreateCancelButtons
                                createText={tripId ? "Save Changes" : "Create"}
                                loading={!!loading?.length}
                                createBtnStyles={{
                                    width: tripId ? '158px' : "80px",
                                }}
                                onCancel={() => {
                                    if (isEditTrip) {
                                        setIsEditTrip(false)
                                    } else {
                                        close()
                                    }
                                }}
                            />
                        }
                    </div>
                }
            </form>
        );
    }
;

